import React, { PureComponent } from 'react';
import Autosuggest from 'react-autosuggest';
import './autoSuggest.scss';

export class AutoSuggest extends PureComponent {
  constructor() {
    super();
    this.state = {
      suggestions: [],
    };
  }

  onClear = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFetch = ({ value, reason }) => {
    if (reason === 'input-focused') {
      return;
    }
    this.getSuggestions(value);
  };

  getSuggestions = async (value) => {
    const { fetchSuggestions } = this.props;
    const suggestions = await fetchSuggestions(value);

    this.setState({ suggestions });
  };

  renderSuggestion = (suggestion) => <div>{suggestion}</div>;

  getSuggestionValue = (suggestion) => {
    return suggestion;
  };

  onEnter = (e) => {
    const { value, onSelect, enableSelectionOnEnter } = this.props;
    if (e.key === 'Enter' && enableSelectionOnEnter && Boolean(value.trim())) {
      onSelect(e, { suggestion: value });
    }
  };

  renderInputComponent = (props) => {
    return <input {...props} onKeyPress={this.onEnter} />;
  };

  render() {
    const { suggestions } = this.state;
    const {
      value,
      name,
      placeholder,
      onChange,
      onSelect,
      errorFlag,
      errorMessage,
      InputComponent = this.renderInputComponent,
    } = this.props;

    return (
      <div className={errorFlag ? 'error' : ''}>
        <Autosuggest
          onSuggestionSelected={onSelect}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onFetch}
          onSuggestionsClearRequested={this.onClear}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderInputComponent={InputComponent}
          inputProps={{
            placeholder,
            value,
            name,
            onChange,
          }}
        />
        <p className="error-message">{errorMessage}</p>
      </div>
    );
  }
}

AutoSuggest.defaultProps = {
  placeholder: 'Please Select',
  value: '',
  name: '',
  onChange: () => {},
  fetchSuggestions: () => {},
  enableSelectionOnEnter: false,
};
